// extracted by mini-css-extract-plugin
export default {"collapsible":"_275cI","title":"_118t_","noTextTransform":"_1k6eD","text":"wnLBS","collapsedContent":"_4lVqE","collapsed":"_12H5g","tanakCollapsed":"_3qOaO","content":"_3TjQi"};